export default "__VITE_ASSET__CvO6YgEC__"